import React, { useState, useEffect } from "react";
import { useQuery } from "react-query";
import * as helpers from "../../utils/utils"

import { useUnits } from "../../hooks/useUnits";
import { usePrices } from "../../hooks/usePrices";

const SlotForm = ({ initialData = {}, onSubmit }) => {
  const { retrieveUnits } = useUnits()
  const { retrievePrices } = usePrices();

  const [slot, setSlot] = useState({});

  const { 
    data: units, 
    isLoading: unitsIsLoading, 
    error: unitsError 
  } = useQuery(
    "unitData",
    () => retrieveUnits(),
    {
      staleTime: 1000 * 60 * 30,          // 30 minutes
      refetchOnWindowFocus: false,        // prevent re-fetch on tab switch
      cacheTime: 1000 * 60 * 60,          // 1 hour cache
    }
  );

  const { 
    data: prices, 
    isLoading: pricesIsLoading, 
    error: pricesError 
  } = useQuery(
    "priceData",
    () => retrievePrices(),
    {
      staleTime: 1000 * 60 * 30,          // 30 minutes
      refetchOnWindowFocus: false,        // prevent re-fetch on tab switch
      cacheTime: 1000 * 60 * 60,          // 1 hour cache
    }
  );

  useEffect(() => {
    setSlot({ ...{} , ...initialData });
  }, [initialData]);

  const onChange = (field, value) => {
    setSlot((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const submit = (e) => {
    e.preventDefault();
    if (slot.date && slot.unitId && slot.priceId && slot.status) {
      onSubmit(slot);
    }
  };

  const reset = (e) => {
    e.preventDefault();
    setSlot(initialData || {});
  };

  return (
    <form className="p-3 border rounded">

      <div className="mb-3">
        <label className="form-label">Date</label>
        <input
          type="date"
          id="date"
          className="form-control"
          value={helpers.dateValToNumeric(slot.date)}
          onChange={(e) => onChange("date", helpers.dateNumericToVal(e.target.value))}
          readOnly={true}
        />
      </div>

      <div className="mb-3">
        <label className="form-label">Unit</label>
        {units ? (
          <select
          className="form-control"
          value={slot.unitId}
          onChange={(e) => onChange("unitId", e.target.value)}
        >
          <option value="">Select a unit</option>
          {units.map((unit) => (
            <option key={unit.id} value={unit.id}>
              {unit.name || unit.label || unit.id}
            </option>
          ))}
        </select>
        ) : (
          <input
            type="text"
            className="form-control"
            value={slot.unitId}
            readOnly
          />
        )}

      </div>


      <div className="mb-3">
        <label className="form-label">Price (Name/Total/Deposit)</label>
        {prices ? (
          <select
            className="form-control"
            value={slot.priceId}
            onChange={(e) => onChange("priceId", e.target.value)}
          >
            <option value="">Select a Price</option>
            {prices.map((price) => (
              <option key={price.id} value={price.id}>
                {price.name + " | " + price.price  + " | " + price.deposit}
              </option>
            ))}
          </select>
        ) : (
          <input
            type="text"
            className="form-control"
            value={slot.unitId}
            readOnly
          />
        )}

      </div>

      <div className="mb-3">
        <label className="form-label">Status</label>
        <select
            className="form-control"
            value={slot.status}
            onChange={(e) => onChange("status", e.target.value)}
          >
            <option value="">Select a Status</option>
            <option value="available">Available</option>
            <option value="unavailable">Unavailable</option>
          </select>
      </div>

      <div className="modal-btn-container">
        <button className="form-secondary-btn btn" onClick={reset}>Reset</button>
        <button className="form-primary-btn btn" onClick={submit}>Submit</button>
      </div>
    </form>
  );
};

export default SlotForm;
